module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAMAAAB1owf/AAAAPFBMVEUAAACDPSmFOiuEPSmAQCWDPSmDPimEQCiEPSqDPSmDPimEPSmDPCyEPSmDPSqFPSmEPSuEOyeCPSuDPSn8MdcaAAAAE3RSTlMA7zDfEIDPIJ9QkHBAv6+vcHBg9o/tggAAAH9JREFUKM910NsShSAIhWEUyaz2cb3/u5ZOTCXy337DiNDRN9O4GSE6gDH9AYcmeAR4BG3phU+YUi8fD2htwBYohTZCgwS1jbwhzgP66Qq2t0uJXcoBt7eE40XxpK3C84YFaM1x0fPepjRD7FLuyNxJk+f2bEErLwVbKiJr/fIOFIUOMbP7me0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/icon-phone.png
// module id = TTWp
// module chunks = 0